import { ROSELoader } from './rose';

export class QuestLogicData {
  scripts: any[] = [];

  static load(path: any, callback: any) {
    ROSELoader.load(path, function(rh: any) {
      const data = new QuestLogicData();

      const size = rh.readUint32();
      const scriptCount = rh.readUint32();
      /* name */ rh.readUint16Str();

      function readStrQuestData() {
        const vardata: any = {};
        vardata.varNo = rh.readUint16();
        vardata.varType = rh.readUint16();
        vardata.value = rh.readUint16();
        vardata.op = rh.readUint8();
        /* padding */ rh.skip(1);
        return vardata;
      }

      function readStrAbilData() {
        const abildata: any = {};
        abildata.type = rh.readInt32();
        abildata.value = rh.readInt32();
        abildata.op = rh.readUint8();
        /* padding */ rh.skip(3);
        return abildata;
      }

      function readStrItemData() {
        const itmdata: any = {};
        itmdata.itemSn = rh.readUint32();
        itmdata.where = rh.readInt32();
        itmdata.count = rh.readInt32();
        itmdata.op = rh.readUint8();
        /* padding */ rh.skip(3);
        return itmdata;
      }

      data.scripts = [];
      for (let i = 0; i < scriptCount; ++i) {
        const script: any = {};

        const triggerCount = rh.readUint32();
        /* script name */ rh.readUint16Str();

        script.triggers = [];
        let previousTrigger: any = null;
        for (let j = 0; j < triggerCount; ++j) {
          const trigger: any = {};

          trigger.checkNext = rh.readUint8() !== 0;
          const condCount = rh.readUint32();
          const rewdCount = rh.readUint32();
          trigger.name = rh.readUint16Str();

          if (previousTrigger) {
            previousTrigger.nextTriggerName = trigger.name;
          }
          previousTrigger = trigger;

          trigger.conditions = [];
          trigger.actions = [];

          for (let k = 0; k < condCount; ++k) {
            let ins: any = {};
            const triggerRhStart = rh.tell();
            const insSize = rh.readUint32();
            ins.type = rh.readUint32();
            switch (ins.type) {
              case 0:
                ins.questID = rh.readUint32();
                break;
              case 1:
                let varCount1 = rh.readInt32();
                ins.vars = [];
                for (let l = 0; l < varCount1; ++l) {
                  ins.vars.push(readStrQuestData());
                }
                break;
              case 2:
                const varCount2 = rh.readInt32();
                ins.vars = [];
                for (let l = 0; l < varCount2; ++l) {
                  ins.vars.push(readStrQuestData());
                }
                break;
              case 3:
                const abilCount = rh.readInt32();
                ins.abils = [];
                for (let l = 0; l < abilCount; ++l) {
                  ins.abils.push(readStrAbilData());
                }
                break;
              case 4:
                const itemCount = rh.readInt32();
                ins.items = [];
                for (let l = 0; l < itemCount; ++l) {
                  ins.items.push(readStrItemData());
                }
                break;
              case 5:
                ins.isLeader = rh.readUint8() !== 0;
                rh.skip(3);
                ins.level = rh.readInt32();
                ins.reversed = rh.readUint8() !== 0;
                rh.skip(3);
                break;
              case 6:
                ins.zoneNo = rh.readInt32();
                ins.x = rh.readInt32();
                ins.y = rh.readInt32();
                ins.z = rh.readInt32();
                ins.radius = rh.readInt32();
                break;
              case 7:
                ins.time = rh.readUint32();
                ins.endTime = rh.readUint32();
                break;
              case 8:
                ins.time = rh.readUint32();
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 9:
                ins.skillNo1 = rh.readInt32();
                ins.skillNo2 = rh.readInt32();
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 11:
                ins.who = rh.readUint8();
                rh.skip(1);
                ins.varNo = rh.readInt16();
                ins.value = rh.readInt32();
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 12:
                ins.zone = rh.readUint16();
                rh.skip(2);
                ins.x = rh.readInt32();
                ins.y = rh.readInt32();
                ins.eventId = rh.readInt32();
                break;
              case 13:
                ins.npcNo = rh.readInt32();
                break;
              case 14:
                ins.id = rh.readInt16();
                ins.op = rh.readUint8();
                rh.skip(1);
                break;
              case 15:
                ins.number1 = rh.readUint16();
                ins.number2 = rh.readUint16();
                break;
              case 16:
                ins.who = rh.readUint8();
                ins.time = rh.readUint32();
                ins.endTime = rh.readUint32();
                break;
              case 17:
                ins.npcVar1 = { npcNo: rh.readInt32(), varNo: rh.readUint16() };
                rh.skip(2);
                ins.npcVar2 = { npcNo: rh.readInt32(), varNo: rh.readUint16() };
                rh.skip(2);
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 20:
                ins.no1 = rh.readInt32();
                ins.no2 = rh.readInt32();
                break;
              case 23:
                ins.reg = rh.readUint8();
                rh.skip(3);
                break;
              case 24:
                ins.pos = rh.readInt16();
                ins.op = rh.readUint8();
                rh.skip(1);
                break;
              case 25:
                ins.cont = rh.readInt16();
                ins.op = rh.readUint8();
                break;
              case 26:
                ins.grd = rh.readInt16();
                ins.op = rh.readUint8();
                rh.skip(1);
                break;
              case 27:
                ins.point = rh.readUint16();
                ins.op = rh.readUint8();
                rh.skip(1);
                break;
              case 28:
                ins.money = rh.readInt32();
                ins.op = rh.readUint8();
                break;
              case 29:
                ins.memberCnt = rh.readInt16();
                ins.op = rh.readUint8();
                break;
              case 30:
                ins.skill1 = rh.readInt16();
                ins.skill2 = rh.readInt16();
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 31:
                ins.questNo = rh.readUint32();
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 32:
                ins.op = rh.readUint8();
                rh.skip(1);
                ins.triggerName = rh.readUint16Str();
                rh.skip(3);
                break;
              case 36:
                ins.op = rh.readUint8();
                rh.skip(3);
                break;
              case 10:
              case 18:
              case 21:
              case 22:
              case 33:
              case 34:
              case 37:
              case 38:
                rh.skip(insSize - 8);
                ins = null;
                break;
              default:
                console.warn('Encountered unknown condition type:', ins.type);
                rh.skip(insSize - 8);
                break;
            }
            const totalRead = rh.tell() - triggerRhStart;
            if (totalRead !== insSize) {
              console.warn('Encountered corrupt condition trigger:', ins.type, '(read:', totalRead, 'expected:', insSize + ')');
              rh.seek(triggerRhStart + insSize);
            }
            if (ins) {
              trigger.conditions.push(ins);
            }
          }

          for (let k = 0; k < rewdCount; ++k) {
            const actionStart = rh.tell();
            const insSize = rh.readUint32();
            // QSD reward types are uint8 + 3 alignment bytes, unlike the
            // uint32 condition type. The marker only needs UPDATE_QUEST's
            // quest ID/operation; retain the type for every other reward and
            // skip its type-specific payload safely by instruction size.
            const action: any = { type: rh.readUint8() };
            rh.skip(3);
            if (action.type === 0) {
              action.questID = rh.readUint32();
              action.operation = rh.readUint8();
            }
            rh.seek(actionStart + insSize);
            trigger.actions.push(action);
          }

          script.triggers.push(trigger);
        }

        if (previousTrigger && previousTrigger.checkNext) {
          previousTrigger.checkNext = false;
        }

        data.scripts.push(script);
      }

      callback(data);
    });
  }
}
